import { render } from "./FreelanceCardSkeleton.vue?vue&type=template&id=2acd9990&scoped=true"
const script = {}

import "./FreelanceCardSkeleton.vue?vue&type=style&index=0&id=2acd9990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acd9990"]])

export default __exports__